/**
 * Created by bdunn on 21/10/2014.
 */
module.exports = require("./lib/modelValidator.js");